import { useEffect, useState } from "react";
import { getPublicPaymentMode } from "@/lib/payments/mode-switch.functions";

type ModeState = { mode: "test" | "live"; switchActive: boolean; expiresAt: string | null };

/** Prominent site-wide notice whenever Razorpay Test Mode applies to this address. */
export function TestModeBanner() {
  const [state, setState] = useState<ModeState | null>(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      getPublicPaymentMode()
        .then((s) => { if (alive) setState(s as ModeState); })
        .catch(() => { /* unknown mode: show nothing; the server still decides payments */ });
    void load();
    const id = window.setInterval(load, 60_000);
    return () => { alive = false; window.clearInterval(id); };
  }, []);

  const isTest = state?.mode === "test";
  useEffect(() => {
    (window as { __CB16_PAYMENT_TEST_MODE__?: boolean }).__CB16_PAYMENT_TEST_MODE__ = isTest;
  }, [isTest]);

  if (!isTest) return null;
  const until = state?.expiresAt
    ? new Date(state.expiresAt).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" })
    : null;
  return (
    <div role="status" className="sticky top-0 z-[60] bg-destructive text-destructive-foreground">
      <p className="mx-auto max-w-7xl px-4 py-2 text-center text-[11px] font-semibold uppercase tracking-[0.2em]">
        Test Mode — payments are simulated, no real money is charged
        {state?.switchActive ? " · Sign in to place test orders" : ""}
        {until ? ` · Returns to Live at ${until} IST` : ""}
      </p>
    </div>
  );
}
